import { useMutation } from "@apollo/client";
import { UPDATE_COMPANY } from "../graphql/company";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

export interface AllocationTypeSetting {
  key: string;
  name: string;
  integrationSourceSystem: string;
  integrationEntity: string;
  editable: boolean;
}

export const useUpdateAllocationTypeSettings = () => {
  const { t } = useTranslation();
  const [updateAllocationTypeSettings, { loading }] =
    useMutation(UPDATE_COMPANY);
  const [selectedCompanyId, setSelectedCompanyId] = useState<string>("");
  const [selectedItems, setSelectedItems] = useState<{
    [key: string]: AllocationTypeSetting;
  }>({});

  const update = async (): Promise<boolean> => {
    try {
      const allocationTypes = Object.entries(selectedItems).map(
        ([key, value]) => ({
          key,
          ...(value.integrationEntity
            ? {
                integrationSourceSystem: value.integrationSourceSystem,
                integrationEntity: value.integrationEntity,
              }
            : {}),
          editable: value.editable,
        }),
      );

      await updateAllocationTypeSettings({
        variables: {
          id: selectedCompanyId,
          input: {
            settings: {
              ALLOCATION_TYPES: allocationTypes,
            },
          },
        },
      });

      toast.success(t("Allocation settings updated successfully"));
      return true;
    } catch (error: unknown) {
      const message = error instanceof Error ? error.message : String(error);
      toast.error(t("Failed to update allocation settings") + ": " + message);
      return false;
    }
  };

  return {
    selectedCompanyId,
    selectedItems,
    setSelectedCompanyId,
    setSelectedItems,
    update,
    loading,
  };
};
